import { render, staticRenderFns } from "./onlyBottomTabBar.vue?vue&type=template&id=3863e3e3&scoped=true&lang=pug&"
import script from "./onlyBottomTabBar.vue?vue&type=script&lang=js&"
export * from "./onlyBottomTabBar.vue?vue&type=script&lang=js&"
import style0 from "./onlyBottomTabBar.vue?vue&type=style&index=0&id=3863e3e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3863e3e3",
  null
  
)

export default component.exports